import { Typography, Space } from 'antd';
import './PageShell.css';

const { Title } = Typography;

interface PageShellProps {
  title?: React.ReactNode;
  description?: React.ReactNode;
  extra?: React.ReactNode;
  filters?: React.ReactNode;
  children: React.ReactNode;
  fullHeight?: boolean;
  hideHeader?: boolean;
  compact?: boolean;
  className?: string;
}

export function PageShell({ title, description, extra, filters, children, fullHeight = true, hideHeader = false, compact = false, className }: PageShellProps) {
  return (
    <div
      data-page-shell
      className={className}
      style={
        fullHeight
          ? { display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0, minWidth: 0 }
          : { minWidth: 0 }
      }
    >
      {/* Page header */}
      {!hideHeader && (
        <div
          data-page-shell-header
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: filters ? (compact ? 6 : 8) : (compact ? 8 : 16),
            flexWrap: 'wrap',
            gap: 8,
          }}
        >
          <div>
            <Title level={4} style={{ margin: 0 }}>
              {title}
            </Title>
            {description ? (
              <Typography.Text type="secondary" style={{ display: 'block', marginTop: 4 }}>
                {description}
              </Typography.Text>
            ) : null}
          </div>
          {/*
            TCR-1506 — `data-page-shell-actions` để print stylesheet ẩn cả cụm nút hành động
            (In / Chỉnh sửa / Gửi email…). Đánh dấu ở đây thay vì nhắm `.ant-btn` toàn cục:
            bản in của một số trang có bảng chứa nút hiển thị dữ liệu, ẩn hết là mất nội dung.
          */}
          {extra && <Space wrap data-page-shell-actions>{extra}</Space>}
        </div>
      )}

      {/* Filters row */}
      {filters && <div style={{ marginBottom: compact ? 8 : 12 }}>{filters}</div>}

      {/* Page content */}
      <div
        data-page-shell-content
        style={
          fullHeight
            ? { display: 'flex', flexDirection: 'column', minHeight: 0, flex: 1, minWidth: 0 }
            : { minWidth: 0 }
        }
      >
        {children}
      </div>
    </div>
  );
}
